import React from 'react';
import { themes } from '../types';

interface NumberWheelProps {
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    disabled: boolean;
    theme: typeof themes[keyof typeof themes];
}

export function NumberWheel({ value, onChange, min, max, disabled, theme }: NumberWheelProps) {
    return (
        <div className="flex items-center gap-2">
            <input
                type="number"
                value={value}
                onChange={(e) => onChange(Math.max(min, Math.min(max, parseInt(e.target.value) || min)))}
                min={min}
                max={max}
                disabled={disabled}
                className={`w-20 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${theme.border} ${theme.ring} ${theme.text} ${theme.card}`}
            />
            <span className={theme.text}>seconds</span>
        </div>
    );
}
